/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react';
import { Typography, Card } from '@mui/material';
import BackButton from '../BackButton';
import PreventDrowsiness from "../../../../../../assets/images/ArticleImages/ADAS-Features-to-Prevent-Drowsiness.webp";
import DrivingWhileTired from "../../../../../../assets/images/ArticleImages/DrivingWhileTired.webp";
import SmartTips from "../../../../../../assets/images/ArticleImages/SmartTips.webp";
import Myths from "../../../../../../assets/images/ArticleImages/Myths.webp";
import AIPowered from "../../../../../../assets/images/ArticleImages/AIPowered.webp";

// Define a type for the content blocks
type ContentBlock =
    | { type: 'heading'; value: string; variant?: 'h4' | 'h5' | 'h6' | 'subtitle2'; style?: React.CSSProperties }
    | { type: 'paragraph'; value: string; style?: React.CSSProperties }
    | { type: 'image'; src: string; alt?: string; style?: React.CSSProperties };

const HowToAvoidSleep: React.FC = () => {
    // Page header information
    const title = "How to Avoid Sleep While Driving: ADAS Features to Prevent Drowsiness";
    const headerImageSrc = PreventDrowsiness;

    // Define the content of your article as a list of blocks.
    const contentBlocks: ContentBlock[] = [
        {
            type: 'paragraph',
            value: "Driving has become the most vital aspect of the world, and several jobs are tied to it. The first is being cautious or vigilant while driving. A nodding driver is the silent assassin for many who have lost their lives worldwide in drowsy driving accidents. This is as lucky as it can get owing to advanced systems like ADAS that are in place to change the face of road safety in unimaginable ways today. Novus Hi-Tech is one of the companies leading in this innovation: keeping the driver alert and safe on the road.",
        },
        {
            type: 'heading',
            value: "Understanding the Dangers of Driving While Tired",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'image',
            src: DrivingWhileTired,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '100%', height: 'auto', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: "This fatigue impairs a person’s concentration power and reaction time, making it one of the predominant causes of road accidents. According to findings of various research, if a person is awake for 18 hours or more, then that is equivalent to having a blood alcohol concentration(BAC) of 0.05%. This significantly reduces a person’s reaction time at the wheel. Drowsiness can creep up on you when you’re behind the wheel. However, by that time you are aware only when you keep yawning repeatedly, cannot focus well, and drift between lanes. Now, learn the dangers and act proactively if you wonder how to avoid sleep while driving a car while you are driving.",
        },
        {
            type: 'heading',
            value: "Smart Tips to Avoid Fatigue on the Road",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'image',
            src: SmartTips,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '100%', height: 'auto', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: "Being vigilant during long drives or late-night commutes requires a preparatory approach and mindfulness. Here are some practical tips to decrease drowsiness risk.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                1.<strong> Take regular breaks</strong> Even the more experienced drivers need rest to avoid wearing and tearing in over hours of driving. Let’s see how to avoid sleep while driving –  Get a break every two hours and stretch, refresh, and refocus. Better use such break times to walk around, get some snacks, and give your eyes rest.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                2.<strong> Hydrating yourself,</strong> dehydration will result in fatigue and decreased concentration. Carry a bottle of water and drink frequently. Avoid sweet drinks and a lot of caffeine because they spark energy, then bring significant crashes after the peak.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                3.<strong> Select Energizing Foods</strong> Snacking on light, energy-boosting foods will keep you alert. Fresh fruits, nuts, and whole grains should be taken instead of heavy, greasy meals that make one so lazy.
                </>
            ) as unknown as string,
        },
        {
            type: 'heading',
            value: "Beware of Common Alertness Myths",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'image',
            src: Myths,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '100%', height: 'auto', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: "One needs to prepare and be mindful while on long drives or late-night commutes. Here are some actionable strategies to reduce the risk of drowsiness:",
        },
        {
            type: 'paragraph',
            value: "Many drivers resort to short-term energy solutions during long trips, especially at night. Such “myths of alertness” include rolling down windows, playing loud music, or relying solely on caffeine. Of course, these tricks pass the short-term test but are ineffective in the long run and create a false sense of security.",
        },
        {
            type: 'paragraph',
            value: "Rather, effective strategies include good sleep, rehydration, and technological support. Those who are curious about what can prevent drowsiness while night driving will be amazed at the differences that tools such as AI-powered ADAS can make.",
        },
        {
            type: 'heading',
            value: "AI-Powered DMS for Safer Driving",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'image',
            src: AIPowered,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '100%', height: 'auto', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: "Advanced Driver Assistance Systems or ADAS are transforming the face of road safety. These systems are most impactful in that direction because they track the activity of drivers with advanced AI and send out warnings in critical cases.",
        },
        {
            type: 'paragraph',
            value: "Another interesting feature that is associated with ADAS is the Driver Monitoring System, wherein it identifies signs of drowsiness – in the way of eyelid movements and facial expressions, for example, and alerts the driver to take a break or seek further assistance.",
        },
        {
            type: 'heading',
            value: "Driver Monitoring Systems: Revolutionizing Road Safety with ADAS",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: (
                <>
                    Advanced Driver Assistance Systems (ADAS) are reshaping the future of road safety by leveraging cutting-edge AI to monitor driver activity and issue critical warnings when necessary. Among the standout features of ADAS is the<strong> Driver Monitoring System (DMS)—</strong> a groundbreaking innovation that plays a vital role in preventing accidents caused by driver fatigue or inattention.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                    DMS is designed to detect signs of drowsiness or distraction through advanced tracking of<strong> eyelid movements, facial expressions,</strong> and head positioning. When these indicators are flagged, the system sends timely alerts, prompting the driver to take a break or seek necessary assistance. This proactive approach significantly reduces the risk of fatigue-related accidents, ensuring safer journeys.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: "With innovations like DMS, Novus Hi-Tech, and similar pioneers are contributing to safer roads and a more secure driving experience for everyone. These advancements underline the transformative impact of ADAS in creating a future where technology takes the wheel for better safety and reliability.",
        },
        {
            type: 'heading',
            value: "Conclusion",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: "Fatigue-related accidents are preventable only with the right preparation and tools. Lifestyle adjustments such as regular breaks, proper hydration, and ideal food may prevail; but technology plays a great role, too. AI systems, like those developed by the company Novus Hi-Tech, are revolutionizing the way people perceive drowsiness in drivers, bringing new safety possibilities to the road.",
        },
    ];

    // Function to render each content block based on its type.
    const renderContentBlock = (block: ContentBlock, index: number) => {
        switch (block.type) {
            case 'heading':
                return (
                    <Typography
                        key={index}
                        variant={block.variant || 'h4'}
                        style={{ fontWeight: 600, ...block.style }}
                    >
                        {block.value}
                    </Typography>
                );
            case 'paragraph':
                return (
                    <Typography
                        key={index}
                        variant="body1"
                        style={{
                            fontSize: '16px',
                            fontWeight: 400,
                            lineHeight: '24px',
                            // color: 'gray',
                            ...block.style,
                        }}
                    >
                        {block.value}
                    </Typography>
                );
            case 'image':
                return (
                    <Card
                        key={index}
                        style={{
                            overflow: 'hidden',
                            borderRadius: 12,
                            ...block.style,
                        }}
                    >
                        <img
                            src={block.src}
                            alt={block.alt || 'Article image'}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    </Card>
                );
            default:
                return null;
        }
    };

    return (
        <div className="flex flex-col w-full">
            <BackButton />

            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', alignItems: 'center' }}>
                {/* Header Section */}
                <div
                    style={{
                        width: '100%',
                        maxWidth: '766px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px',
                    }}
                >
                    {/* Title & Tag Section */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <Typography variant="h4" style={{ fontWeight: 600 }}>
                            {title}
                        </Typography>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                gap: '8px',
                            }}
                        >
                        </div>
                    </div>

                    {/* Header Image */}
                    <Card
                        style={{
                            width: '100%',
                            height: 384,
                            borderRadius: 12,
                            overflow: 'hidden',
                        }}
                    >
                        <img
                            src={headerImageSrc}
                            alt="Article header image"
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    </Card>
                </div>

                {/* Content Section */}
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px',
                        width: '100%',
                        maxWidth: '766px',
                        padding: '16px 0',
                    }}
                >
                    {contentBlocks.map((block, index) => renderContentBlock(block, index))}
                </div>
            </div>
        </div>
    );
};

export default HowToAvoidSleep;

